<!--
 * @Date: 2021-04-29 08:01:49
 * @LastEditors: natsu
 * @LastEditTime: 2021-05-12 07:54:29
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vue.png" /></div>
      <p>Vuex</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/vuex/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "4.1.0",
          linkList: [
            ur + "4.1.0/vuex.global.js",
            ur + "4.1.0/vuex.global.min.js",
            ur + "4.1.0/vuex.global.prod.js"
          ]
        },
        {
          label: "3.6.2",
          linkList: [ur + "3.6.2/vuex.js", ur + "3.6.2/vuex.min.js"]
        },
        {
          label: "3.1.3",
          linkList: [ur + "3.1.3/vuex.js", ur + "3.1.3/vuex.min.js"]
        },
        {
          label: "3.1.1",
          linkList: [ur + "3.1.1/vuex.js", ur + "3.1.1/vuex.min.js"]
        },
        {
          label: "3.1.0",
          linkList: [ur + "3.1.0/vuex.js", ur + "3.1.0/vuex.min.js"]
        },
        {
          label: "3.0.1",
          linkList: [ur + "3.0.1/vuex.js", ur + "3.0.1/vuex.min.js"]
        },
        {
          label: "3.0.0",
          linkList: [ur + "3.0.0/vuex.js", ur + "3.0.0/vuex.min.js"]
        },
        {
          label: "2.5.0",
          linkList: [ur + "2.5.0/vuex.js", ur + "2.5.0/vuex.min.js"]
        },
        {
          label: "2.4.0",
          linkList: [ur + "2.4.0/vuex.js", ur + "2.4.0/vuex.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVuex.vue